/* eslint-disable */
import { connect } from "react-redux"

// action creators
import {
    setSearchTerm,
    storeScrollTopPositions,
    toggleHideFilterSet,
} from "app/static/frontend/search-new/action-creators"

import { setActiveActionButton } from "shared/search/action-creators"

import { sendAction } from "shared/djangio/action-creators"

import { updateUserdata } from "shared/userdata/userdata-action-creators"

// selectors
import {
    selectActiveActionButton,
    selectCurrentFilters,
    selectHasNewFiltersOnInitialLoad,
    selectHasNonProtectedCurrentFilters,
} from "shared/search/selectors"

import {
    selectAiSearchFilters,
    selectIsAiSearchApplied,
    selectFilterSetScrollTop,
    selectSearchTerm,
} from "app/static/frontend/search-new/selectors"

import { selectSearchShouldHideFilters } from "shared/userdata/userdata-selectors"

// components
import FilterSet from "app/static/frontend/search-new/components/FilterSet/index"

const mapStateToProps = (state, props) => ({
    activeActionButton: selectActiveActionButton(state, props),
    aiSearchFilters: selectAiSearchFilters(state, props),
    filterSetScrollTop: selectFilterSetScrollTop(state, props),
    isAiSearchApplied: selectIsAiSearchApplied(state, props),
    hasNewFiltersOnInitialLoad: selectHasNewFiltersOnInitialLoad(state, props),
    hasNonProtectedCurrentFilters: selectHasNonProtectedCurrentFilters(state, props),
    searchTerm: selectSearchTerm(state, props),
    shouldHideFilters: selectSearchShouldHideFilters(state, props),
})

const actions = {
    sendAction,
    setActiveActionButton,
    setSearchTerm,
    storeScrollTopPositions,
    updateUserdata,
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    // need to pass this as a prop here to avoid circular import in app/static/frontend/search-new/components/FilterSet/index.js
    toggleHideFilterSet,
})

export default connect(mapStateToProps, actions, mergeProps)(FilterSet)
